module.exports = __webpack_public_path__ + "img/bigScreen-img01.bc1f8074.png";